export default "__VITE_ASSET__h0b1ft2k__"